import React from 'react';

const ElementsContext = React.createContext(null);

function ElementsContextProvider({ children }) {
	const [elements, setElements] = React.useState({
		holder: { complete: false },
		card_number: { complete: false },
		expiry: { complete: false },
		cvv: { complete: false },
	});

  return (
		<ElementsContext.Provider
			value={[
				elements,
				setElements,
			]}
		>
			{children}
		</ElementsContext.Provider>
	);
}

export { ElementsContextProvider, ElementsContext };